// extracted by mini-css-extract-plugin
module.exports = {"container":"isbn-tile_container__MhYYF","image":"isbn-tile_image__hPmL4","title":"isbn-tile_title__cfQxt","stats":"isbn-tile_stats__sS0GV"};